import { oneOf } from 'prop-types';
import React from 'react';
import { Badge } from 'reactstrap';

import { COMPLIANCE_COLOR_MAP, complianceStatuses } from '../../constants';

function Compliance({ compliance }) {
  const color = COMPLIANCE_COLOR_MAP[compliance];
  return (
    compliance && (
      <Badge pill color={color}>
        {compliance}
      </Badge>
    )
  );
}

Compliance.propTypes = {
  compliance: oneOf(Object.values(complianceStatuses)),
};

Compliance.defaultProps = {
  compliance: complianceStatuses.NONE,
};

export default Compliance;
